import React, { useEffect, useRef, useState } from 'react';
import styles from './UploadFile.module.scss';
import { ProgressBarLine } from '../gamificationTooltip/gamificationTooltip';
import icons from '../../assets';
import { apiPostImageOnPresignedData } from '../../helpers/api';
import { checkIfImage, getFileSize } from '../../screens/Requests/Sections/helper';
import { download } from '../../common/DownloadFileController/downloadFile';
import { Image, Loader } from '../../common';
import { useDispatch, useSelector } from 'react-redux';
import {
  requestsSelector,
  setCurrentRequestFilesSize,
  setFilesUploadProgress,
  setFilesUploadStatus
} from '../../redux/slicers/requestSlicer';
import cx from 'classnames';
import { ElipsisTooltip } from '../../common/ElipsisTooltip';

function UploadedFiles({
  _file,
  onDeleteClick,
  isReadOnly,
  variant = null,
  className = '',
  hideProgressBar = false,
}) {
  const _requestSelector = useSelector(requestsSelector);

  const { WrongCrossIcon, RequestDeleteIcon, DownloadIcon } = icons;
  const [downloadLoading, setDownloadLoading] = useState(false);
  const wrapperRef = useRef();
  const dispatch = useDispatch();
  const [windowSize, setWindowSize] = useState({ width: 1920, height: 1080 });

  const setProgress = (_value) => {
    dispatch((dispatch) => {
      dispatch(setFilesUploadProgress({ [_file.id]: _value }));
    });
  };

  const handleResize = () => {
    setWindowSize({
      width: wrapperRef.current?.parentNode.offsetWidth,
      height: wrapperRef.current?.parentNode.offsetHeight,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(async () => {
    if (_file?.presigned_data_file) {
      setProgress(0);
      dispatch(setFilesUploadStatus({ [_file.id]: false }));

      try {
        const response = await apiPostImageOnPresignedData(
          _file.file,
          _file.presigned_data_file,
          (event) => {
            setProgress((event.loaded / event.total) * 100);
          }
        );

        if (response.status === 204) {
          dispatch(setFilesUploadStatus({ [_file.id]: true }));
          setProgress(100);
        }
      } catch {
        dispatch(setFilesUploadStatus({ [_file.id]: 'failed' }));
      }
    }
  }, []);

  useEffect(() => {
    setWindowSize({
      width: wrapperRef?.current?.parentNode.offsetWidth,
      height: wrapperRef?.current?.parentNode.offsetHeight,
    });
  }, [wrapperRef.current]);

  const handleDownloadClick = async (_file) => {
    if (downloadLoading) return;
    setDownloadLoading(true);
    await download({ fileUrl: _file.url, fileName: _file.filename });
    setDownloadLoading(false);
  };

  const handleDeleteClick = () => {
    dispatch(setFilesUploadStatus({ [_file.id]: true }));
    onDeleteClick();
  };

  console.log(_requestSelector.filesUploadStatus, _requestSelector.filesUploadProgress);

  const FileExtAsComponent = () => (
    <div className={styles.fileName}>{_file?.file?.name.split('.').at(-1).toUpperCase()}</div>
  );

  return variant !== 2 ? (
    <div className="d-flex w-100 align-items-center">
      <div className={styles.typeBox}>{_file.file.name.split('.').at(-1).toUpperCase()}</div>
      <div className="d-flex flex-column w-100 flex-auto py-3 px-4">
        <div className="d-flex pb-2 justify-content-between">
          <span>{_file.file.name}</span>
          <div className="d-flex gap-3">
            <span>{getFileSize(_file.file.size)}</span>
            {!isReadOnly && (
              <div className={styles.closeIconWrapper} onClick={onDeleteClick}>
                <WrongCrossIcon />
              </div>
            )}
          </div>
        </div>
        {!hideProgressBar ? (
          <ProgressBarLine
            className={styles.progessBar}
            progress={_requestSelector?.filesUploadProgress[_file.id]}
          />
        ) : null}
      </div>
    </div>
  ) : (
    <div
      ref={wrapperRef}
      className={cx(styles.variant2Box, className)}
      // style={!isReadOnly ? { height: `${windowSize.width * 0.30835}px` } : {}}
    >
      {_file?.file.name ? (
        checkIfImage(_file?.file.name) ? (
          !isReadOnly ? (
            <Image src={_file.url} ratio={1.3} />
          ) : (
            <Image src={_file.url} ratio={1.3} rounded={false} />
          )
        ) : (
          <Image src={_file.url} ratio={1.3} Icon={FileExtAsComponent} />
        )
      ) : null}

      {!isReadOnly ? (
        <div className={styles.process}>
          <ProgressBarLine
            className={cx(
              styles.progessBar,
              _requestSelector?.filesUploadProgress?.[_file.id] === 100 && styles.complete
            )}
            progress={_requestSelector?.filesUploadProgress?.[_file.id]}
          />
          {_file.file.size ? (
            <span data-toggle="tooltip" data-placement="top" title={getFileSize(_file.file.size)}>
              {getFileSize(_file.file.size)}
            </span>
          ) : null}
        </div>
      ) : null}

      <div className={styles.titleBar}>
        <ElipsisTooltip title={_file.file?.name}>
          {({ ref, onMouseEnter, onMouseLeave }) => (
            <span
              ref={ref}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              data-toggle="tooltip"
              data-placement="top">
              {_file.file.name}
            </span>
          )}
        </ElipsisTooltip>

        {_requestSelector?.filesUploadStatus &&
        _requestSelector.filesUploadStatus[_file.id] === 'failed' ? (
          <div className={styles.failedOverlay}>FAILED</div>
        ) : (
          <div className={styles.downloadIcon} onClick={() => handleDownloadClick(_file)}>
            {downloadLoading ? (
              <Loader loading={true} position="relative" thickness={1} size={14} />
            ) : (
              <DownloadIcon />
            )}
          </div>
        )}
      </div>

      {!isReadOnly ? (
        <div
          onClick={() => {
            handleDeleteClick(_file.id);
          }}
          className={styles.svgWrapper}>
          {' '}
          <RequestDeleteIcon />
        </div>
      ) : null}
    </div>
  );
}

export default UploadedFiles;
